import React from "react";
import { ArrowLeft, ArrowRight } from "react-feather";
import { PropTypes } from "prop-types";
import { InertiaLink } from "@inertiajs/inertia-react";

const Button = ({
  children,
  className = "",
  onClick = (_) => null,
  showArrowRight = true,
  showArrowLeft = false,
  theme = "black",
  ...props
}) => {
  // define classes for the button based on the theme prop
  let themeClasses = "";
  switch (theme) {
    case "black":
      themeClasses =
        "bg-gray-darker text-white shadow-sm disabled:bg-gray-inactive";
      break;
    case "white":
      themeClasses = "bg-white text-gray-darker";
      break;
    default:
      themeClasses = "bg-gray-darker text-white shadow-sm";
  }

  return (
    <ButtonWrapper
      className={`group relative flex gap-2 self-start px-6 py-3 font-medium max-md:px-4 ${themeClasses} ${className}`}
      onClick={onClick}
      {...props}
    >
      {showArrowLeft && <ArrowLeft />}
      <div className="relative overflow-hidden">
        <div
          className={`relative top-0 translate-y-0 transform transition-transform duration-300 ease-[cubic-bezier(.68,-0.55,.27,1.55)] ${props?.disabled ? "" : "group-hover:-translate-y-full"}`}
        >
          {children}
        </div>
        <div
          className={`absolute top-full translate-y-0 transform transition-transform duration-300 ease-[cubic-bezier(.68,-0.55,.27,1.55)] ${props?.disabled ? "" : "group-hover:-translate-y-full"}`}
        >
          {children}
        </div>
      </div>
      {showArrowRight && <ArrowRight />}
    </ButtonWrapper>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  showArrowRight: PropTypes.bool,
  showArrowLeft: PropTypes.bool,
  theme: PropTypes.oneOf(["black", "white"]),
};

export default Button;

const ButtonWrapper = ({ children, ...props }) => {
  if (props.href) {
    return (
      <a href={props.href} {...props}>
        {children}
      </a>
    );
  }

  return <button {...props}>{children}</button>;
};
